<script setup>

</script>

<template>
    • In-house Training: $10,000 tuition
    • Virtual Training: $5,000 tuition  *not available yet*
    • Adult Education: $4,000 tuition
    • Add caveat: All courses require students to purchase tools ($3,000) and supplies/materials ($1,000)
</template>

<style scoped>

</style>
